<template>
  <div class="list-itme d-flex bg-content border-bottom">
    <div class="flex-fill">
      <router-link v-if="data.postInfo_postID.typeID===1" :to="'/blog/p/'+data.postInfo_postID.postID">
        <h4 class='article-title'>{{ data.postInfo_postID.title | textTrans }}</h4>
        <p class="descript" v-html="$options.filters.textTrans(data.postInfo_postID.msgbody)"></p>
      </router-link>
      <router-link v-if="data.postInfo_postID.typeID===2"
                   :to="'/group/p/'+data.indexingInfo_postID.groupinfoID+'?topicID=0&postID='+data.postInfo_postID.postID">
        <h4 class='article-title'>{{ data.postInfo_postID.title | textTrans }}</h4>
        <p class="descript" v-html="$options.filters.textTrans(data.postInfo_postID.msgbody)"></p>
      </router-link>
      <div class="list-itme-tail d-flex align-items-center py-1 title pl-0">
        <div>
          <el-popover
              placement="top-start"
              :width="340"
              trigger="hover"
              :open-delay="700"
          >
            <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">

            </User-Infor-Card>
            <a  slot="reference" v-if="$store.state.user.check_is_wxcblog_domain()"
                :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
              <div  slot="reference" class="group-small d-flex align-self-center">
                <div v-if="!data.userinfo_userID.avatar" class="avatar-word mr-1">
                  {{ data.userinfo_userID.first_letter }}
                </div>
                <img style="width: 30px;height: 30px"
                     v-if="data.userinfo_userID.avatar"
                     v-bind:alt="data.userinfo_userID.username"
                     class="rounded-circle mr-1"
                     v-bind:src="data.userinfo_userID.avatar"
                >
                <!--              </router-link>-->

                <div class="name">{{ data.userinfo_userID.username| textTrans }}</div>
                <!--            <icon-V class="text-primary lable" style="font-size: 18px" v-if="data.userinfo_userID.is_hot_blogger"></icon-V>-->


                <!--            <div class="name float-left">-->
                <!--              {              <icon-V class="text-primary lable" v-if="data.userinfo_userID.is_hot_blogger"></icon-V>-->
                <!--              {data.userinfo_userID.username | textTrans}}-->
                <!--            </div>-->
              </div>
            </a>
            <router-link
                v-else
                slot="reference"
                :to="'/blog/user/'+data.userID">
<!--                :to="'/userindex/'+data.userID">-->
              <div class="blog-small  d-flex align-self-center">
                <div class="group-small d-flex align-self-center">
                  <div v-if="!data.userinfo_userID.avatar" class="avatar-word mr-1">
                    {{ data.userinfo_userID.first_letter }}
                  </div>
                  <img style="width: 30px;height: 30px"
                       v-if="data.userinfo_userID.avatar"
                       v-bind:alt="data.userinfo_userID.username"
                       class="rounded-circle mr-1"
                       v-bind:src="data.userinfo_userID.avatar"
                  >
                  <!--              </router-link>-->

                  <div class="name">{{ data.userinfo_userID.username| textTrans }}</div>
                  <!--            <icon-V class="text-primary lable" style="font-size: 18px" v-if="data.userinfo_userID.is_hot_blogger"></icon-V>-->


                  <!--            <div class="name float-left">-->
                  <!--              {              <icon-V class="text-primary lable" v-if="data.userinfo_userID.is_hot_blogger"></icon-V>-->
                  <!--              {data.userinfo_userID.username | textTrans}}-->
                  <!--            </div>-->
                </div>
              </div>
            </router-link>
          </el-popover>
        </div>

        <!--          </template>-->
        <!--        </el-popover>-->
        <div class="tail-data">
          <!--  <span>
         <span class="icons" v-html="icons.like_outline"></span>
            {{data.countinfo_postID.count_buzz}}
         </span> -->
          <!-- <span class="ml-3">
         <span class="icons" v-html="icons.message"></span>
            {{data.countinfo_postID.count_comment}}
         </span>  -->
          <span class="ml-3" v-if="type=='bookmark'">
              <a herf="javascript:void(0)" v-if="data.postInfo_postID.is_bookmark==1"
                 @click="deletBookmark(data.postID)">取消收藏</a>
            </span>

          <!-- <a class="ml-3" v-if="data.userID==$store.state.user.userinfo.UserID" href="javascript:void(0)" style="color:#39b8eb" @click="gotoEditor(data)">编辑</a> -->
          <!-- <el-popconfirm  v-if="data.userID==$store.state.user.userinfo.UserID"
            placement="top-end"
            confirm-button-text='删除'
            cancel-button-text='取消'
            title="确定删除这篇文章吗？"
            :hide-icon="true"
            @confirm="article_delete(data)"
          >
            <a href="javascript:void(0)" slot="reference" class="ml-3" style="color:#39b8eb">删除</a>
          </el-popconfirm> -->
        </div>
      </div>
    </div>
    <div
        id="image"
        class='list-itme-image'
        v-if="data.postInfo_postID.pic"
        v-bind:style="{backgroundImage:'url('+data.postInfo_postID.pic+')'}">
      <router-link :to="'/blog/p/'+data.postID">
        <!--      <router-link :to="'/'+data.indexingInfo_postID.typeID===1?'blog':'group'+'/p/'+data.postID">-->
        <div class="imgspace" id="imgspace"></div>
      </router-link>
    </div>
  </div>
</template>
<script>
// import UserInforCard from './UserInforCard';
// import {
//   IconV
// } from '@/components/Icons';
import icons from '@/components/Icons/Icons.js'
import {textTrans} from '@/directives/textTrans.js';
import UserInforCard from '@/module/user/components/UserInforCard';

export default {
  name: 'article-list-item',
  props: {
    type: String,
    data: {
      countinfo_postID: {},
      create_date: Number,
      id: Number,
      postID: Number,
      postInfo_postId: {
        typeID:1
      },
      title: String,
      userID: Number,
      userinfo_userID: {}
    }
  },
  components: {
    // IconV,
    UserInforCard
  },
  data() {
    return {
      icons: icons,
    }
  },
  methods: {
    deletBookmark(postID) {
      this.$emit('delete-bookmark', postID);
    },
    // article_delete(item){
    //   blog.article_delete(item.postID,0).then(res=>{
    //     if(res.status){
    //       this.$forceUpdate()
    //     }
    //   })
    // },
    // gotoEditor(item){
    //   let url = '/blog/my/editor/?postid='+item.postID
    //   this.$router.push(url);
    // }
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  }
};
</script>
<style>
h4 {
  margin-top: 0 !important;
}

.avatar-word, .small .avatar-word {
  border-radius: 50%;
  background-color: #eeeeee;
  line-height: 35px;
  min-width: 35px;
  text-align: center;
  font-weight: 500;
  -webkit-box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  cursor: pointer;
}

.blog-small img {
  -webkit-box-shadow: 0 3px 8px 0 rgb(0 0 0 / 17%);
  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 17%);
  cursor: pointer;
}

.avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.list-itme {
  /*border-bottom: 1px solid #eee;*/
  margin-top: 0px;
}

.list-itme .list-itme-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  margin: auto .85rem;
}

.list-itme a {
  color: #14171a;
  text-decoration: none;
}

.imgspace {
  width: 160px;
  height: 105px;
}

h4.article-title {
  margin-bottom: .5rem;
  margin-top: 1rem;
  font-weight: 600;
  font-size: 1.2em
}

h4.article-title:hover, .name.el-popover__reference:hover {
  color: #235592
}

.list-itme .descript {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.list-itme .descript:hover {
  color: #646464
}

p.descript, div.list-itme-tail {
  color: #121212;
  line-height: 1.6;
  font-size: 1rem;
  font-weight: normal;
}

.list-itme-tail .name {
  color: #333;
  cursor: pointer;
  line-height: 35px;
}

.list-itme-tail .hover {
  color: #027C04
}

.list-itme-tail .tail-data {
  font-size: 0.95rem;
  padding-right: 1rem;
  padding-top: 8px;
  color: #5b7083;
}

.list-itme-tail .tail-data a {
  cursor: pointer;
}

.tail-data .icons svg {
  stroke: gray;
  height: 16px;
  width: 16px;
}

p.descript {
  margin-bottom: 0.25rem;
}

@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }
}
</style>